"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Icon = require("../../Icon");
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
    title: 'This field cannot be edited once saved.',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.EditOffIcon, {
      fontSize: 'small'
    })
  });
};